import { ApiErrorResponseWithCode } from '@vfde-sails/utils';

/**
 * Check if an object is an ApiErrorResponseWithCode
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ApiErrorResponseWithCode
 */
export const isApiError = (error: unknown): error is ApiErrorResponseWithCode => {
    return null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;
};
